import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=303ff685&scoped=true&"
var script = {}
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=303ff685&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ff685",
  null
  
)

export default component.exports